module.exports = __webpack_public_path__ + "static/media/sun-full.5c37ed03.svg";